<div class="p-grid ">
  <div class="p-col-10 m-auto p-mt-5">
    <div class="p-col-12">
      <p>
        {{'GESTION.HEADER.TEXTO1' | translate}}
      </p>
      <p>
        {{'GESTION.HEADER.TEXTO2' | translate}}
      </p>
    </div>
    <div class="p-col-12">
      <p-card class="p-xl-4 p-lg-12 p-md-12 p-sm-12" header="{{'GESTION.REGISTRO.TITULO' | translate}}">
        <p class="py-2">
          {{'GESTION.REGISTRO.TEXTO1' | translate}}
        </p>
        <ul>
          <li>
            {{'GESTION.REGISTRO.TEXTO2' | translate}}
          </li>
          <li>
            {{'GESTION.REGISTRO.TEXTO3' | translate}}
          </li>
        </ul>
      </p-card>
      <p-card class="p-xl-4 p-lg-12 p-md-12 p-sm-12" header="{{'GESTION.ALERTAS.TITULO' | translate}}">
        <p class="py-2">
          {{'GESTION.ALERTAS.TEXTO1' | translate}}
        </p>
        <ol>
          <li>
            {{'GESTION.ALERTAS.TEXTO2' | translate}}
          </li>
          <li>
            {{'GESTION.ALERTAS.TEXTO3' | translate}}
          </li>
        </ol>
      </p-card>
      <p-card class="p-xl-4 p-lg-12 p-md-12 p-sm-12" header="{{'GESTION.HISTORIAL.TITULO' | translate}}">
        <p class="py-2">
          {{'GESTION.HISTORIAL.TEXTO1' | translate}}
        </p>
        <p>
          {{'GESTION.HISTORIAL.TEXTO2' | translate}}
        </p>
      </p-card>
    </div>
    <div class="p-col-12 p-d-flex p-jc-center">
      <div class="p-col-8 preguntas-frecuentes p-d-flex p-jc-center" (click)="goTo('/preguntas-frecuentes')">
        <span>{{'GLOBAL.PREGUNTAS.FRECUENTES' |translate}}</span>
      </div>
    </div>
    <div class="p-col-12 p-d-flex p-jc-center">
      <div class="p-col-8 preguntas-frecuentes p-d-flex p-jc-center" (click)="goTo('/tramites')">
        <span>{{'GLOBAL.TRAMITES.DISPONIBLES' |translate}}</span>
      </div>
    </div>
  </div>
</div>